import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
// -*- mode: jsx;-*-
import PureRenderMixin from './external-adapters/pureRenderMixinAdapter.js';
/* global proposalMessageFormatter */


export const SupporterMessage = createReactClass({
    propTypes: {
        message: PropTypes.object.isRequired,

        challengeId: PropTypes.string,
    },

    mixins: [PureRenderMixin],

    render: function () {
        const props = this.props;
        const message = props.message;
        let proposalURL = message.proposalURL;

        if (props.challengeId) {
            proposalURL += '?challengeid=' + props.challengeId;
        }

        const author = <span dangerouslySetInnerHTML={{ __html: message.author.capitalizeFirstLetter() }}></span>;
        const locationAndDonorTeacherRelationship = proposalMessageFormatter.getLocationAndDonorTeacherRelationship(message.location, message.donorTeacherRelationship);

        return (
            <li>
                <span className="activity-timestamp">{message.createDatePhrase}</span>
                <div className="activity-item">
                    <div className="action">
                        <span className={'user-avatar' + (message.grantAccount === 'true' ? ' partner' : '')} style={{ backgroundImage: 'url(' + message.photoURL + ')' }} />
                        <div className="activity-description">
                            <p>
                                {author}{locationAndDonorTeacherRelationship} gave
                                {message.count > 1 ? ` ${message.count} times` : ''}
                                {message.proposalTitle ? <span> to <a href={proposalURL} dangerouslySetInnerHTML={{ __html: message.proposalTitle }}></a></span> : null}
                            </p>
                        </div>
                    </div>
                    {message.message
                        ? <div className="comment" dangerouslySetInnerHTML={{ __html: message.message }}>
                        </div>
                        : null }
                </div>
            </li>
        );
    },
});
